import {effect, Inject, Injectable} from '@angular/core';
import {ENV_TOKEN, EnvInterface} from 'env-config';
import {ScriptGenerator} from '../../../projects/products-lib/src/lib/scripts/script-generator';
import {CookieConsentService} from '../../services/cookie-consent.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly GA_SCRIPT_ID = 'ga-gtm-script';
  private readonly GA_INLINE_SCRIPT_ID = 'ga-gtag-inline-script';
  // Read by quiz clients (MixedOnlineTests) in the same-origin iframe before they load their own tag
  private readonly ANALYTICS_ALLOWED_WINDOW_KEY = 'cgpAnalyticsAllowed';

  constructor(
    @Inject(ENV_TOKEN)
    protected readonly environment: EnvInterface,
    private cookieConsentService: CookieConsentService,
  ) {
  }

  loadGApiScript() {
    // Always add the base URL preconnect link
    document.head.appendChild(
      ScriptGenerator.createBaseUrlLink(this.environment.security.baseUrl)
    );

    // Reactively load or disable GA based on analytics consent
    effect(() => {
      const analyticsEnabled = this.cookieConsentService.preferences().analytics;
      (window as any)[this.ANALYTICS_ALLOWED_WINDOW_KEY] = analyticsEnabled;
      if (analyticsEnabled) {
        this.addGAScripts();
      } else {
        this.disableGA();
      }
    });
  }

  private addGAScripts() {
    (window as any)[this.gaDisableKey()] = false;
    if (document.getElementById(this.GA_SCRIPT_ID)) {
      return; // Already added
    }

    const gtmScript = ScriptGenerator.createGoogleTagManagerScript(
      this.environment.googleAnalytics.trackerId,
      'qv7MJ8V5SPSg5jE0U0T4TA=='
    );
    gtmScript.id = this.GA_SCRIPT_ID;
    document.head.appendChild(gtmScript);

    if (this.environment.app.environment === 'development') {
      console.log('createLocalGTagScript debugMode ', this.environment.googleAnalytics.debugMode);
    }

    const inlineScript = ScriptGenerator.createLocalGTagScript(
      'qv7MJ8V5SPSg5jE0U0T4TA==',
      this.environment.googleAnalytics.debugMode,
      this.environment.googleAnalytics.trackerId
    );
    inlineScript.id = this.GA_INLINE_SCRIPT_ID;
    document.head.appendChild(inlineScript);
  }

  // Removing the script tags would not unload gtag.js once it has run, so the scripts stay and
  // Google's opt-out flag stops it sending anything. If they were never added, nothing is sent anyway.
  private disableGA() {
    (window as any)[this.gaDisableKey()] = true;
  }

  private gaDisableKey(): string {
    return `ga-disable-${this.environment.googleAnalytics.trackerId}`;
  }
}
